__turbopack_context__.v({
  "passport_buttons": "A0uSgG_passport_buttons",
  "passport_show_info": "A0uSgG_passport_show_info",
  "passport_thumbnail": "A0uSgG_passport_thumbnail",
  "passport_thumbnail_image": "A0uSgG_passport_thumbnail_image",
  "passport_thumbnail_image_link": "A0uSgG_passport_thumbnail_image_link",
  "passport_thumbnail_passport_badge": "A0uSgG_passport_thumbnail_passport_badge",
  "show_description": "A0uSgG_show_description",
  "show_logo": "A0uSgG_show_logo",
  "show_title": "A0uSgG_show_title",
});
